import formScreenshotDe from "../../assets/join-hospitality/screenshot-onboard-form-de.jpg";
import formScreenshotIt from "../../assets/join-hospitality/screenshot-onboard-form-it.jpg";
import sidebarScreenshotDe from "../../assets/join-hospitality/screenshot-onboard-sidebar-de.jpg";
import sidebarScreenshotIt from "../../assets/join-hospitality/screenshot-onboard-sidebar-it.jpg";
import { useTranslations } from "../../hooks/useTranslations";
import Page from "../ui/Page";
import styles from "./JoinJobOffers.module.css";

const assets = {
  de: {
    sidebarScreenshot: sidebarScreenshotDe,
    formScreenshot: formScreenshotDe,
  },
  it: {
    sidebarScreenshot: sidebarScreenshotIt,
    formScreenshot: formScreenshotIt,
  },
};

const JoinJobOffers = () => {
  const { i18n, currentLanguage } = useTranslations();
  const t = i18n.joinJobOffers;
  const steps = t.steps;
  const { sidebarScreenshot, formScreenshot } = assets[currentLanguage];

  return (
    <Page
      title={i18n.departments.joinHospitality.apps.joinJobOffers.title}
      backLinkText={i18n.departments.joinHospitality.backLink}
    >
      <h2>{t.title}</h2>

      <ol>
        <li>
          {steps.new}
          <img
            className={styles.sidebarImage}
            src={sidebarScreenshot}
            alt={t.sidebarScreenshotAltText}
          />
        </li>

        <li>
          {steps.basicInfo.label}
          <ul>
            {steps.basicInfo.items.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
          <img
            className={styles.formImage}
            src={formScreenshot}
            alt={t.formScreenshotAltText}
          />
        </li>

        <li>
          {steps.content.label}
          <ul>
            {steps.content.items.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
          <p>{steps.content.note}</p>
        </li>

        <li>{steps.employmentType}</li>

        <li>{steps.salary}</li>

        <li>{steps.autoReply}</li>

        <li>
          {steps.beforePublishing.label}
          <ol type="a">
            {steps.beforePublishing.items.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ol>
        </li>
      </ol>

      <p>{t.duplicateHint}</p>
    </Page>
  );
};

export default JoinJobOffers;
